import { get } from 'lodash';
import * as asyncUtils from 'ui-permit/shared-components/utils/async';
import { SHARED_PREFIX } from 'ui-permit/shared-components/constants';
import { getReservationSummaryImageUrlReducer } from 'ui-permit/shared-components/reducers';

const INITIAL_STATE = {
    reservationSummaryImageUrl: ''
};

const shared = asyncUtils.mergeReducers(INITIAL_STATE, SHARED_PREFIX,
    getReservationSummaryImageUrlReducer
);

export default shared;

export const selectors = {
    getImageUrlSelector: (state) => get(state, 'shared.reservationSummaryImageUrl', '')
};
